import { createContext, destroyContext } from 'modern-screenshot'

let screenshotContext: any = null
let initializationPromise: Promise<any> | null = null

export async function getScreenshotContext(element: HTMLElement) {
  if (screenshotContext) {
    return screenshotContext
  }

  if (initializationPromise) {
    return initializationPromise
  }

  initializationPromise = createContext(element, {
    workerNumber: 2 // Use 2 workers for better performance
  })

  try {
    screenshotContext = await initializationPromise
    return screenshotContext
  } finally {
    initializationPromise = null
  }
}

export function cleanupScreenshotContext() {
  if (screenshotContext) {
    destroyContext(screenshotContext)
    screenshotContext = null
  }
}
